<template>
  <div>
    <div v-if="criteriaFilters.length">
      <table
        v-for="(criteria, index) in criteriaData"
        :key="index"
        class="criteria-data purple-color"
      >
        <tr>
          <th>Mode: <strong>{{ getSegmentDescription(criteria.mode) }}</strong></th>
          <th><span class="mr-3">|</span>Operator: <strong>{{ criteria.operation | uppercase }}</strong></th>
          <th>{{ criteria.count }}</th>
        </tr>
        <tr v-if="criteria.name">
          <td colspan="3">
            {{ criteria.name | capitalize }}
          </td>
        </tr>
        <tr
          v-for="(content, index2) in criteria.content"
          :key="index2"
        >
          <td colspan="3">
            <template v-if="content.nodeType === 'filter'">
              <div v-html="createFilterElement(content)" />
            </template>
            <template v-if="content.nodeType === 'segment'">
              <Criteria
                :criteria-data="[content]"
                :filters="filters"
              />
            </template>
          </td>
        </tr>
      </table>
    </div>
    <div
      v-else
      id="filtersLoader"
    >
      Loading...
    </div>
  </div>
</template>
<script>
import Criteria from '../components/Criteria'
import moment from 'moment'
import localeFormat from '../constants/dateFormat'

export default {
  name: 'Criteria',
  components: {
    Criteria
  },
  props: {
    criteriaData: Array,
    filters: Array
  },
  data () {
    return {
      criteriaFilters: {},
      isLoading: true
    }
  },
  mounted () {
    if (this.filters) {
      this.criteriaFilters = this.filters.map(element => {
        return {
          id: element.id,
          name: element.name,
          applicationName: element.applicationName,
          typeName: element.typeName,
          lookupValues: element.lookupValues
        }
      })
    }
  },
  methods: {
    getFormattedValue (value) {
      let formattedValue = value
      if (!isNaN(Date.parse(value))) {
        const locale = this.$store.getters.getLocale
        const formatDate = localeFormat.dateFormat(locale)
        formattedValue = moment(String(value)).format(formatDate)
      }
      return formattedValue
    },
    getSegmentDescription (mode) {
      const dict = {
        combine: 'Combine',
        include: 'include',
        include_customer_id: 'Include by Customer ID',
        include_customer_email: 'Include by Email',
        exclude_customer_id: 'Exclude by Customer ID',
        exclude: 'Exclude by Customer ID',
        exclude_customer_email: 'Exclude by Email',
        exclude_email: 'Exclude by Email'
      }
      return dict[mode]
    },
    renderLookupMultipleFilterDescription (type, element, filter) {
      let lookupValues = []
      let description = ''
      element.value.forEach(function (elementValue) {
        filter.lookupValues.forEach(function (lookup) {
          if (lookup.key && lookup.key.toString() === elementValue.toString()) {
            lookupValues.push(lookup.value)
          }
        })
      })
      if (element.operation !== 'in_defined_list') {
        lookupValues = lookupValues.sort((a, b) => a.value - b.value)
      }
      description += '<ul class="filter-value-list">'
      lookupValues.forEach(function (value) {
        description += '<li><span class="filter-value">' + value + '</span></li>'
      })
      description += '</ul>'
      return description
    },
    renderLookupFreeFormFilterDescription (type, element, filter) {
      const lookupValues = []
      let description = ''
      if (element.operation === 'in_defined_list') {
        element.value.forEach(function (elementValue) {
          lookupValues.push(elementValue)
        })
      } else {
        element.value.forEach(function (elementValue) {
          filter.lookupValues.forEach(function (lookup) {
            if (lookup.key && lookup.key.toString() === elementValue.toString()) {
              lookupValues.push(lookup.value)
            }
          })
        })
      }
      description += '<ul class="filter-value-list">'
      lookupValues.forEach(function (value) {
        description += '<li><span class="filter-value">' + value + '</span></li>'
      })
      description += '</ul>'
      return description
    },
    renderNumberStringDateFilterDescription (type, element, filter) {
      const value = element.value || ''
      const dateValue = this.getFormattedValue(value)
      const dict = {
        number: {
          equal: 'is equal to ' + value,
          not_equal: 'is not equal to ' + value,
          less_than: 'is less than ' + value,
          less_than_or_equal: 'is less than or equal to ' + value,
          greater_than: 'is greater than ' + value,
          greater_than_or_equal: 'is greater than or equal to ' + value,
          between: 'is between ' + (value ? value[0] : '') + ' and ' + (value ? value[1] : ''),
          is_null: 'is null',
          is_not_null: 'is not null'
        },
        string: {
          equal: 'is ' + value,
          not_equal: 'is not ' + value,
          starts_with: 'starts with ' + value,
          not_starts_with: "doesn't start with " + value,
          ends_with: 'ends with ' + value,
          not_ends_with: "doesn't end with " + value,
          contains: 'contains ' + value,
          not_contains: "doesn't contain " + value,
          is_null: 'is null',
          is_not_null: 'is not null'
        },
        domain: {
          equal: 'is ' + value,
          not_equal: 'is not ' + value,
          starts_with: 'starts with ' + value,
          not_starts_with: "doesn't start with " + value,
          ends_with: 'ends with ' + value,
          not_ends_with: "doesn't end with " + value,
          contains: 'contains ' + value,
          not_contains: "doesn't contain " + value,
          is_null: 'is null',
          is_not_null: 'is not null'
        },
        date: {
          on: 'is on ' + dateValue,
          not_on: 'is not on ' + dateValue,
          before: 'is before ' + dateValue,
          on_or_before: 'is before or on ' + dateValue,
          after: 'is after ' + dateValue,
          on_or_after: 'is on or after ' + dateValue,
          in_last_days: 'is in the last number of days: ' + value,
          in_last_weeks: 'is in the last number of weeks: ' + value,
          in_last_months: 'is in the last number of months: ' + value,
          in_last_years: 'is in the last number of years: ' + value,
          in_next_days: 'is in the next number of days: ' + value,
          in_next_weeks: 'is in the next number of weeks: ' + value,
          in_next_months: 'is in the next number of months: ' + value,
          in_next_years: 'is in the next number of years: ' + value,
          between: 'is between ' + (value ? this.getFormattedValue(value[0]) : '') + ' and ' + (value ? this.getFormattedValue(value[1]) : ''),
          between_last_days: 'is between the last ' + (value ? value[0] : '') + ' and ' + (value ? value[1] : '') + ' days',
          between_next_days: 'is between the next ' + (value ? value[0] : '') + ' and ' + (value ? value[1] : '') + ' days',
          exactly_days_ago: 'is exactly this number of days ago: ' + value,
          exactly_days_future: 'is exactly this number of days in the future: ' + value,
          today: 'is today',
          is_null: 'is null',
          is_not_null: 'is not null'
        }
      }
      return dict[type][element.operation]
    },
    renderFilterDescription (type, element, filter) {
      let description = ''

      // Title
      if (type === 'number' || type === 'string' || type === 'date' || type === 'domain') {
        description += '<span class="criteria--title">' + filter.name + ' </span>'
      } else if (type === 'lookup_multiple' || type === 'boolean' || type === 'lookup_single') {
        description += '<span class="criteria--title">' + filter.name + ': </span>'
      }

      // Subtitle
      description += '<span class="criteria--subtitle">'
      if (type === 'number' || type === 'string' || type === 'date' || type === 'domain') {
        description += this.renderNumberStringDateFilterDescription(type, element, filter)
      } else if (type === 'lookup_single') {
        if (element.value[0]) {
          description += filter.lookupValues.find(lookupValue => lookupValue.key.toString() === element.value[0].toString()).value
        }
      } else if (type === 'lookup_multiple' || type === 'boolean') {
        description += this.renderLookupMultipleFilterDescription(type, element, filter)
      } else if (type === 'lookup_freeform') {
        if (element.operation === 'in' || element.operation === 'in_defined_list') {
          description += '<span class="criteria--title">' + filter.name + ': </span>'
          description += this.renderLookupFreeFormFilterDescription(type, element, filter)
        } else {
          description += '<span class="criteria--title">' + filter.name + ' </span>'
          description += this.renderNumberStringDateFilterDescription('string', element, filter)
        }
      } else {
        description += '<span class="criteria--title">' + filter.name + ' </span>'
      }
      description += '</span>'
      return description
    },
    createFilterElement (element) {
      if (this.criteriaFilters && this.criteriaFilters.length > 0) {
        const filter = this.criteriaFilters.find(x => x.applicationName === element.name)
        const type = filter.typeName
        return this.renderFilterDescription(type, element, filter)
      }
    },
    loadFilters () {
      return new Promise((resolve, reject) => {
        const parentCompanyId = this.$route.query.clientId
        const projectId = this.$route.query.campaignId
        const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : null
        this.$store.dispatch('setCampaignAudienceFilters', { parentCompanyId, projectId, userEmail })
          .then(() => resolve())
      })
    }
  }
}
</script>
